import type { ReactNode } from 'react'
import React from 'react'

export const ComponentNotReady = ({ children }: { children?: ReactNode }) => {
  return <div className="text-danger fw-bold">{children ? children : '[TODO] : Developer will implement this'}</div>
}
